import React from 'react';
import { Flex, Badge, Image } from '@spothero/ui';
import { VISUAL_FLAG_TYPES } from 'utils/visual-flags';
import { FACILITY_SUMMARY_VIEW_TYPES } from 'common/facility-summary/utils';
import { v4 as uuidV4 } from 'uuid';
const styles = {
    py: '1px',
    px: '2',
    textAlign: 'center',
    backgroundColor: 'black',
    color: 'white',
    borderRadius: 'base',
    fontSize: 'xs',
    fontWeight: 'semibold',
};
const SpotTags = ({ tags, spotsLeft, facilityTitle, view }) => {
    const message = spotsLeft > 1 ? 'Spots Left' : 'Spot Left';
    if (!tags?.length && !spotsLeft) {
        return null;
    }
    const isListView = view === FACILITY_SUMMARY_VIEW_TYPES.SPOT_LIST;
    return (<Flex mx={3} mt={3} className="SpotTags" data-testid={`SpotTags-${encodeURIComponent(facilityTitle)}`}>
            {Boolean(tags?.length) &&
            tags.map(({ title, type, icon }) => {
                const showIcon = type === VISUAL_FLAG_TYPES.OFFICIAL_PARKING;
                const flagTitle = isListView &&
                    type === VISUAL_FLAG_TYPES.OFFICIAL_PARKING
                    ? 'Official Parking'
                    : title;
                return (<Badge {...styles} mr="2" key={uuidV4()}>
                            <Flex flexDirection="row" alignItems="center" gap="2">
                                {showIcon ? (<Image width="14px" height="14px" data-testid="VisualFlag-Icon" alt={flagTitle} src={!icon ||
                            icon ===
                                'https://res.cloudinary.com/spothero/'
                            ? '/img/official-icon.png'
                            : icon}/>) : null}
                                {flagTitle}
                            </Flex>
                        </Badge>);
            })}
            {Boolean(spotsLeft) && (<Badge {...styles}>
                    {spotsLeft} {message}
                </Badge>)}
        </Flex>);
};
export default SpotTags;
